<!--&lt;!&ndash;-->
<template>
    <div class="panel panel-flat">
        <div class="panel-heading">
            <h5 class="pb-2">Dagens scheman</h5>
        </div>
        <div class="panel-body">
            <div class="row">
                <div class="col-md-12">
                    <filter-bar :date="date"></filter-bar>
                    <vuetable ref="vuetable"
                              :api-url="proxyUrl"
                              :fields="fields"
                              data-path="data"
                              pagination-path=""
                              :per-page="10"
                              :css="css.table"
                              :sort-order="sortOrder"
                              :multi-sort="true"
                              :append-params="moreParams"
                              @vuetable:pagination-data="onPaginationData"
                    ></vuetable>
                    <div class="vuetable-pagination">
                        <vuetable-pagination-info ref="paginationInfo"
                                                  info-template="Visar {from} till {to} av {total} rader"
                                                  no-data-template="Inga scheman hittades"
                                                  info-class="pagination-info"
                        ></vuetable-pagination-info>
                        <vuetable-pagination ref="pagination"
                                             :css="css.pagination"

                                             @vuetable-pagination:change-page="onChangePage"
                        ></vuetable-pagination>
                    </div>
                </div>
            </div>
        </div>
        <hr>
    </div>
</template>

<script>
    import FilterBar from './TableFilter'
    export default {
        name: "DailySchedules",
        props: ['part'],
        components: {
            FilterBar
        },
        data () {
            return {
                date: moment(new Date()).format('YYYY-MM-DD'),
                proxyUrl: this.part.route_refresh,
                fields: [
                    {
                        name: 'location.primary_company',
                        title: 'Företag',
                        sortField: 'location.primary_company.name',
                        callback: 'schedule'
                    },
                    {
                        name: 'location.address',
                        title: 'Lokal',
                        sortField: 'location.address',
                    },
                    {
                        name: 'timespan',
                        title: 'Tider',
                        sortField: 'timespan',
                    },
                    {
                        name: 'freeschedules',
                        title: 'Lediga tider',
                        sortField: 'scheduleratio',
                        dataClass: 'center aligned',
                        callback: 'freeSchedules'
                    },
                    {
                        name: 'therapist',
                        title: 'Terapeut',
                        sortField: 'therapist.user.name',
                        callback: 'therapist'
                    },


                ],
                css: {
                    table: {
                        tableClass: 'table table-bordered table-striped table-hover table-sm',
                        ascendingIcon: '',
                        descendingIcon: ''
                    },
                    pagination: {
                        wrapperClass: 'flex list-reset border border-grey-light rounded pagination',
                        activeClass: 'block text-white bg-primary border-r border-primary px-3 py-2',
                        disabledClass: 'disabled',
                        pageClass: 'block hover:text-white hover:bg-primary text-primary border-r border-grey-light px-3 py-2 cursor-pointer',
                        linkClass: 'block hover:text-white hover:bg-primary text-primary border-r border-grey-light px-3 py-2 cursor-pointer',
                        icons: {
                            first: 'fa fa-angle-double-left',
                            prev: 'fa fa-angle-left',
                            next: 'fa fa-angle-right',
                            last: 'fa fa-angle-double-right',
                        },
                    },
                    icons: {
                        first: 'fa fa-angle-double-left',
                        prev: 'fa fa-angle-left',
                        next: 'fa fa-angle-right',
                        last: 'fa fa-angle-double-right',
                    },
                },
                sortOrder: [
                    { field: 'start', sortField: 'start', direction: 'asc'},
                    { field: 'company.name', sortField: 'company.name', direction: 'asc'},
                ],
                moreParams: {}
            }
        },
        mounted () {
            this.$eventHub.$on('filter-set', this.filter_set);
            this.$eventHub.$on('filter-reset', this.filter_reset);
        },
        methods: {
            onPaginationData (paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage (page) {
                this.$refs.vuetable.changePage(page)
            },
            onCellClicked (data, field, event) {
                this.$refs.vuetable.toggleDetailRow(data.id)
            },
            timeFormat (val) {
                return moment(val.day_start).format('HH:mm') + ' ' + moment(val.day_end).format('HH:mm');
            },
            schedule (val) {
                return val ? `<a href="/companies/${val.id}">${val.name}</div>` : '';
            },
            therapist (val) {
                return `<a href="/therapists/${val.id}">${val.user.name}</div>`;
            },
            freeSchedules (val) {
                let url = `/schedules/?company_id=${val.company}`;
                if(val.ratio % 1 == 0) {
                    return `<h4><a href="${url}" class="badge badge-success" style="width: 100%;">${Math.trunc(val.freeSchedules)}</a></h4>`;
                } else if(val.ratio % 1 > 0.33) {
                    return `<h4><a href="${url}" class="badge badge-danger" style="width: 100%;">${Math.trunc(val.freeSchedules)}</a></h4>`;
                } else {
                    return `<h4><a href="${url}" class="badge badge-warning" style="width: 100%;">${Math.trunc(val.freeSchedules)}</a></h4>`;
                }
            },
            filter_set (filterText) {
                this.moreParams = {
                    filter: filterText.filterText,
                    date: filterText.date,
                }
                this.$nextTick( () => this.$refs.vuetable.refresh() )
            },
            filter_reset () {
                this.moreParams = {}
                this.$nextTick( () => this.$refs.vuetable.refresh() )
            }
        }
    }
</script>

<style scoped>
    .pagination {
        float: right;
    }
    .vuetable-pagination-info {
        float: left;
        padding-bottom: 12px;
    }
    .vuetable {
        margin-bottom: 10px
    }
</style>
